module.exports = __webpack_public_path__ + "static/media/Group 1072 (3).0a6093a5.svg";